import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "antd";
import { useCallback } from "react";
import { OCTOLANE_COLOR_TOKENS } from "~/app/styles/tokens";

import If from "~/core/ui/If";

import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

import { useGlobalCreateOpportunityStore } from "../store";

import { AdditionalFields } from "./AdditionalFields";

const StyledCollapse = styled(Collapse)`
  &.ant-collapse {
    border: none;
    background: none;
  }

  .ant-collapse-item {
    border: none;
  }

  .ant-collapse-header {
    padding: 8px 0 !important;

    .ant-collapse-expand-icon {
      color: ${OCTOLANE_COLOR_TOKENS.text.lighter};
    }
  }

  .ant-collapse-content {
    background: none;
    border: none;
  }
`;

const TransitionIcon = styled(FontAwesomeIcon)<{ $isActive: boolean }>`
  transition: transform 0.2s ease;
  transform: ${props => (props.$isActive ? "rotate(90deg)" : "rotate(0deg)")};
`;

export const Collapsable = () => {
  const opportunityAttributes = useGlobalCreateOpportunityStore(
    state => state.opportunityAttributes,
  );

  const setIsAdditionalFieldsOpen = useGlobalCreateOpportunityStore(
    state => state.setIsAdditionalFieldsOpen,
  );

  const expandIcon = useCallback(
    ({ isActive }: { isActive: boolean }) => {
      setIsAdditionalFieldsOpen(!!isActive);
      return (
        <TransitionIcon
          icon={faChevronRight}
          className="text-sm"
          $isActive={!!isActive}
        />
      );
    },
    [setIsAdditionalFieldsOpen],
  );

  return (
    <If condition={opportunityAttributes.length > 0}>
      <div className="px-3">
        <StyledCollapse
          expandIcon={({ isActive }) => expandIcon({ isActive: !!isActive })}
        >
          <Collapse.Panel
            header={
              <div>Additional Fields ({opportunityAttributes.length})</div>
            }
            key="1"
            className="!border-none"
          >
            <AdditionalFields />
          </Collapse.Panel>
        </StyledCollapse>
      </div>
    </If>
  );
};
